import { RenderEditItem, RenderEditImage } from "./Edit/RenderEdits";
import { RenderSectionItems } from "./Edit/RenderItems";
import { BsChevronCompactDown } from "react-icons/bs";

import "./Preview.css";
import "./PreviewEdit.css";
import { myPageDataEnum } from "../../hooks/useWebpageData";
import { iconLinkMapper } from "../../util/iconMapper";
import { scrollListener, toggleMobileMenu } from "./easyzilla-scripts";
import { useMemo } from "react";

interface PreviewProps {
  editModeEnabled: boolean;
  // TODO: convert to better type
  myPageData: Map<any, any>;
  webpageEditedAction: () => void;
}

export function Preview({
  editModeEnabled,
  myPageData,
  webpageEditedAction,
}: PreviewProps) {
  scrollListener();

  function toggleEnableSection(sectionEnum: string) {
    if (
      !(
        sectionEnum === myPageDataEnum.enableSectionOne ||
        sectionEnum === myPageDataEnum.enableSectionTwo ||
        sectionEnum === myPageDataEnum.enableSectionThree
      )
    ) {
      throw new Error("Invalid section enum");
    }
    myPageData.get(sectionEnum)?.setter((val: boolean) => !val);
    webpageEditedAction();
  }

  const backgroundImageEnabled = useMemo(() => {
    return (
      myPageData.get(myPageDataEnum.backgroundImg)?.value &&
      myPageData.get(myPageDataEnum.backgroundImg)?.value !== ""
    );
  }, [myPageData]);

  const allSectionsDisabled = useMemo(() => {
    return (
      !myPageData.get(myPageDataEnum.enableSectionOne)?.value &&
      !myPageData.get(myPageDataEnum.enableSectionTwo)?.value &&
      !myPageData.get(myPageDataEnum.enableSectionThree)?.value
    );
  }, [myPageData]);

  // TODO: Set these as savable data points
  const primaryColor = "247, 247, 247";
  const secondaryColor = "247, 247, 247";
  const primaryFont = "247, 247, 247";
  const secondaryFont = "0, 0, 0";

  return (
    <div id="webpage" className="webpage">
      <div
        className={backgroundImageEnabled ? "coverBgImg" : "coverBgPattern"}
        style={{
          backgroundImage:
            backgroundImageEnabled &&
            `url(${myPageData.get(myPageDataEnum.backgroundImg)?.value})`,
        }}
      />
      <div id="top" />
      <div id="topHeader" className="topHeader">
        <div className="topHeaderContent">
          <div className="topHeaderTitle">
            <a href={!editModeEnabled ? "#top" : "#edit"}>
              <div className="topHeaderImg">
                <RenderEditImage
                  inputSrc={myPageData.get(myPageDataEnum.logo)}
                  altText="logo"
                  editModeEnabled={editModeEnabled}
                  editToolsOutside
                  saveAction={webpageEditedAction}
                />
              </div>
            </a>
            <a href={!editModeEnabled ? "#top" : "#edit"}>
              <h4>
                <RenderEditItem
                  inputItem={myPageData.get(myPageDataEnum.companyName)}
                  editModeEnabled={editModeEnabled}
                  saveAction={webpageEditedAction}
                />
              </h4>
            </a>
          </div>
          <div className="topHeaderMenu">
            {myPageData.get(myPageDataEnum.enableSectionOne)?.value &&
              myPageData.get(myPageDataEnum.aboutMeTitle)?.value && (
                <div className="topHeaderMenuItem">
                  <a
                    href={`#${myPageData.get(myPageDataEnum.aboutMeTitle)?.value}`}
                    rel="author"
                  >
                    {myPageData.get(myPageDataEnum.aboutMeTitle)?.value}
                  </a>
                </div>
              )}
            {myPageData.get(myPageDataEnum.enableSectionTwo)?.value &&
              myPageData.get(myPageDataEnum.serviceItemsTitle)?.value && (
                <div className="topHeaderMenuItem">
                  <a
                    href={`#${
                      myPageData.get(myPageDataEnum.serviceItemsTitle)?.value
                    }`}
                    rel="author"
                  >
                    {myPageData.get(myPageDataEnum.serviceItemsTitle)?.value}
                  </a>
                </div>
              )}
            {myPageData.get(myPageDataEnum.enableSectionThree)?.value &&
              myPageData.get(myPageDataEnum.otherTitle)?.value && (
                <div className="topHeaderMenuItem">
                  <a
                    href={`#${myPageData.get(myPageDataEnum.otherTitle)?.value}`}
                    rel="author"
                  >
                    {myPageData.get(myPageDataEnum.otherTitle)?.value}
                  </a>
                </div>
              )}
            {!allSectionsDisabled && (
              <div className="topHeaderMenuItem">
                <a href="#footer" rel="author">
                  Contact
                </a>
              </div>
            )}
            {myPageData.get(myPageDataEnum.ctaEnabled)?.value && (
              <div className="topHeaderMenuItem">
                <a
                  href={`${myPageData.get(myPageDataEnum.ctaLink)?.value}`}
                  rel="author"
                  className="webpageTopBtn"
                  style={{
                    backgroundColor: `${myPageData.get(myPageDataEnum.primaryColor)?.value}`,
                    color: `${myPageData.get(myPageDataEnum.secondaryColor)?.value}`,
                  }}
                >
                  {myPageData.get(myPageDataEnum.ctaText)?.value}
                </a>
              </div>
            )}
          </div>
          <div className="topHeaderMenuMobile">
            {!allSectionsDisabled && (
              <div
                id="mobileMenu"
                className="topHeaderMenuMobileItems"
                style={{ display: "none" }}
              >
                {myPageData.get(myPageDataEnum.enableSectionOne)?.value &&
                  myPageData.get(myPageDataEnum.aboutMeTitle)?.value && (
                    <a
                      href={`#${myPageData.get(myPageDataEnum.aboutMeTitle)?.value}`}
                      rel="author"
                      onClick={() => toggleMobileMenu()}
                    >
                      {myPageData.get(myPageDataEnum.aboutMeTitle)?.value}
                    </a>
                  )}
                {myPageData.get(myPageDataEnum.enableSectionTwo)?.value &&
                  myPageData.get(myPageDataEnum.serviceItemsTitle)?.value && (
                    <a
                      href={`#${
                        myPageData.get(myPageDataEnum.serviceItemsTitle)?.value
                      }`}
                      rel="author"
                      onClick={() => toggleMobileMenu()}
                    >
                      {myPageData.get(myPageDataEnum.serviceItemsTitle)?.value}
                    </a>
                  )}
                {myPageData.get(myPageDataEnum.enableSectionThree)?.value &&
                  myPageData.get(myPageDataEnum.otherTitle)?.value && (
                    <a
                      href={`#${myPageData.get(myPageDataEnum.otherTitle)?.value}`}
                      rel="author"
                      onClick={() => toggleMobileMenu()}
                    >
                      {myPageData.get(myPageDataEnum.otherTitle)?.value}
                    </a>
                  )}
                <a
                  href="#footer"
                  rel="author"
                  onClick={() => toggleMobileMenu()}
                >
                  Contact
                </a>
              </div>
            )}

            {myPageData.get(myPageDataEnum.ctaEnabled)?.value && (
              <a
                href={`${myPageData.get(myPageDataEnum.ctaLink)?.value}`}
                rel="author"
                className="webpageTopBtn"
                style={{
                  backgroundColor: `${myPageData.get(myPageDataEnum.primaryColor)?.value}`,
                  color: `${myPageData.get(myPageDataEnum.secondaryColor)?.value}`,
                }}
              >
                {myPageData.get(myPageDataEnum.ctaText)?.value}
              </a>
            )}
            {!allSectionsDisabled && (
              <button
                id="topHeaderMenuMobileButton"
                type="button"
                className="topHeaderMenuMobileButton"
                onClick={() => toggleMobileMenu()}
              >
                <svg
                  id="mobileButtonClose"
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  version="1.1"
                  viewBox="0 0 17 17"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g></g>
                  <path d="M9.207 8.5l6.646 6.646-0.707 0.707-6.646-6.646-6.646 6.646-0.707-0.707 6.646-6.646-6.647-6.646 0.707-0.707 6.647 6.646 6.646-6.646 0.707 0.707-6.646 6.646z"></path>
                </svg>
                <svg
                  id="mobileButtonHamburger"
                  stroke="currentColor"
                  fill="none"
                  stroke-width="0"
                  viewBox="0 0 15 15"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>
      <div
        className="top"
        style={{
          color: `rgb(${primaryFont})`,
          height: `${allSectionsDisabled ? "71.5vh" : "80vh"}`,
        }}
      >
        <div className="topContainer">
          <div className="topTitle">
            <h1>
              <RenderEditItem
                inputItem={myPageData.get(myPageDataEnum.companyTitle)}
                enableTextArea
                editModeEnabled={editModeEnabled}
                saveAction={webpageEditedAction}
                accentColor={myPageData.get(myPageDataEnum.primaryColor)?.value}
              />
            </h1>
          </div>
          {(myPageData.get(myPageDataEnum.companyDescription)?.value ||
            editModeEnabled) && (
            <div className="topDesc">
              <h2>
                <RenderEditItem
                  inputItem={myPageData.get(myPageDataEnum.companyDescription)}
                  enableTextArea
                  editModeEnabled={editModeEnabled}
                  saveAction={webpageEditedAction}
                  accentColor={
                    myPageData.get(myPageDataEnum.primaryColor)?.value
                  }
                />
              </h2>
            </div>
          )}
          {myPageData.get(myPageDataEnum.ctaEnabled)?.value && (
            <div className="webpageCtaWrapper">
              <a
                href={`${myPageData.get(myPageDataEnum.ctaLink)?.value}`}
                rel="author"
                className="webpageCta"
                style={{
                  backgroundColor: `${myPageData.get(myPageDataEnum.primaryColor)?.value}`,
                  color: `${myPageData.get(myPageDataEnum.secondaryColor)?.value}`,
                }}
              >
                {myPageData.get(myPageDataEnum.ctaText)?.value}
              </a>
            </div>
          )}
        </div>
      </div>
      {editModeEnabled && (
        <div className="editButtonWrapper">
          <button
            type="button"
            className="editButton"
            onClick={() => toggleEnableSection(myPageDataEnum.enableSectionOne)}
          >
            {myPageData.get(myPageDataEnum.enableSectionOne)?.value
              ? "Hide 'About' Section"
              : "Enable 'About' Section"}
          </button>
        </div>
      )}
      {myPageData.get(myPageDataEnum.enableSectionOne)?.value && (
        <div
          className="coreButton"
          style={{
            backgroundColor: `rgba(${secondaryColor}, .9)`,
          }}
        >
          <a
            className="mainButton"
            href={`#${myPageData.get(myPageDataEnum.aboutMeTitle)?.value}`}
            rel="author"
            style={{
              color: `rgb(${secondaryFont})`,
            }}
          >
            {myPageData.get(myPageDataEnum.aboutMeTitle)?.value}
            <BsChevronCompactDown />
          </a>
        </div>
      )}
      {myPageData.get(myPageDataEnum.enableSectionOne)?.value && (
        <div
          className="aboutMe"
          id={myPageData.get(myPageDataEnum.aboutMeTitle)?.value}
          style={{
            backgroundColor: `rgba(${secondaryColor}, .9)`,
            color: `rgb(${secondaryFont})`,
          }}
        >
          <div className="sectionTitle">
            <h2>
              <RenderEditItem
                inputItem={myPageData.get(myPageDataEnum.aboutMeTitle)}
                editModeEnabled={editModeEnabled}
                saveAction={webpageEditedAction}
              />
            </h2>
          </div>
          <div
            className="aboutMeContent"
            style={{
              backgroundImage:
                myPageData.get(myPageDataEnum.logo)?.value &&
                myPageData.get(myPageDataEnum.logo)?.value !== "" &&
                myPageData.get(myPageDataEnum.logo)?.value !== "empty"
                  ? `url('${myPageData.get(myPageDataEnum.logo)?.value}')`
                  : `radial-gradient(
                    circle at left center,
                    rgba(255, 255, 255, 0.6) 0%,
                    ${myPageData.get(myPageDataEnum.primaryColor)?.value} 40%,
                    transparent 70%
                  )`,
            }}
          >
            <div className="aboutMeTitleContent">
              <div className="aboutMeImg"></div>
            </div>
            <p>
              <RenderEditItem
                inputItem={myPageData.get(myPageDataEnum.aboutMe)}
                editModeEnabled={editModeEnabled}
                enableTextArea
                saveAction={webpageEditedAction}
              />
            </p>
          </div>
        </div>
      )}
      {myPageData.get(myPageDataEnum.enableSectionTwo)?.value && (
        <div className="coreButton">
          <a
            className="mainButton"
            href={`#${myPageData.get(myPageDataEnum.serviceItemsTitle)?.value}`}
            rel="author"
            style={{
              color: `rgb(${secondaryFont})`,
            }}
          >
            {myPageData.get(myPageDataEnum.serviceItemsTitle)?.value}
            <BsChevronCompactDown />
          </a>
        </div>
      )}
      {editModeEnabled && (
        <div className="editButtonWrapper">
          <button
            type="button"
            className="editButton"
            onClick={() => toggleEnableSection(myPageDataEnum.enableSectionTwo)}
          >
            {myPageData.get(myPageDataEnum.enableSectionTwo)?.value
              ? "Hide 'Features' Section"
              : "Enable 'Features' Section"}
          </button>
        </div>
      )}
      {myPageData.get(myPageDataEnum.enableSectionTwo)?.value && (
        <div
          className="mid"
          id={myPageData.get(myPageDataEnum.serviceItemsTitle)?.value}
          style={{
            color: `rgb(${secondaryFont})`,
          }}
        >
          <div className="sectionTitle">
            <h2
              style={{
                color: myPageData.get(myPageDataEnum.primaryColor)?.value,
              }}
            >
              <RenderEditItem
                inputItem={myPageData.get(myPageDataEnum.serviceItemsTitle)}
                editModeEnabled={editModeEnabled}
                saveAction={webpageEditedAction}
              />
            </h2>
          </div>
          <div className="midCards">
            <RenderSectionItems
              inputItems={myPageData.get(myPageDataEnum.serviceItems)}
              editModeEnabled={editModeEnabled}
              enableImgs
              //setImgAsBackground
              //editToolsOutside
              groupClass="itemCard"
              primaryColor={myPageData.get(myPageDataEnum.primaryColor)?.value}
              saveAction={webpageEditedAction}
            />
          </div>
        </div>
      )}
      {editModeEnabled && (
        <div className="editButtonWrapper">
          <button
            type="button"
            className="editButton"
            onClick={() =>
              toggleEnableSection(myPageDataEnum.enableSectionThree)
            }
          >
            {myPageData.get(myPageDataEnum.enableSectionThree)?.value
              ? "Hide 'FAQ' Section"
              : "Enable 'FAQ' Section"}
          </button>
        </div>
      )}
      {myPageData.get(myPageDataEnum.enableSectionThree)?.value && (
        <div
          className="otherSection"
          id={myPageData.get(myPageDataEnum.otherTitle)?.value}
          style={{
            backgroundColor: `rgba(${primaryColor}, 1)`,
            color: `rgb(${primaryFont})`,
          }}
        >
          <div className="otherTitle">
            <h2 style={{ color: `rgb(${secondaryFont})` }}>
              <RenderEditItem
                inputItem={myPageData.get(myPageDataEnum.otherTitle)}
                editModeEnabled={editModeEnabled}
                saveAction={webpageEditedAction}
              />
            </h2>
          </div>
          <div className="otherContent">
            <div className="otherItems">
              {/* Add more robust icon solution */}
              <RenderSectionItems
                inputItems={myPageData.get(myPageDataEnum.otherItems)}
                editModeEnabled={editModeEnabled}
                enableIcons={false}
                itemClass="otherItem"
                primaryColor={
                  myPageData.get(myPageDataEnum.primaryColor)?.value
                }
                saveAction={webpageEditedAction}
              />
            </div>
          </div>
        </div>
      )}
      <div
        className="footer"
        id="footer"
        style={{
          backgroundColor: `${myPageData.get(myPageDataEnum.primaryColor)?.value}`,
          color: `${myPageData.get(myPageDataEnum.secondaryColor)?.value}`,
        }}
      >
        <div className="footerContent">
          {(myPageData.get(myPageDataEnum.logo)?.value ||
            myPageData.get(myPageDataEnum.companyName)?.value) && (
            <div className="footerImg">
              <RenderEditImage
                inputSrc={myPageData.get(myPageDataEnum.logo)}
                altText={"logo"}
                editModeEnabled={editModeEnabled}
                saveAction={webpageEditedAction}
              />
              <h3>
                <RenderEditItem
                  inputItem={myPageData.get(myPageDataEnum.companyName)}
                  editModeEnabled={editModeEnabled}
                  saveAction={webpageEditedAction}
                />
              </h3>
            </div>
          )}
          <div className="footerContact">
            <h4>Contact Us</h4>
            <p
              style={{
                color: `${myPageData.get(myPageDataEnum.secondaryColor)?.value}`,
              }}
            >
              <RenderEditItem
                inputItem={myPageData.get(myPageDataEnum.addressFreeForm)}
                editModeEnabled={editModeEnabled}
                saveAction={webpageEditedAction}
                placeholder="company address"
              />
            </p>
            <p>
              <a
                style={{
                  color: `${myPageData.get(myPageDataEnum.secondaryColor)?.value}`,
                }}
                href={
                  !editModeEnabled
                    ? `mailto:${myPageData.get(myPageDataEnum.email)?.value}`
                    : "#edit"
                }
              >
                <RenderEditItem
                  inputItem={myPageData.get(myPageDataEnum.email)}
                  editModeEnabled={editModeEnabled}
                  saveAction={webpageEditedAction}
                  placeholder="email address"
                />
              </a>
            </p>
            <p>
              <a
                style={{
                  color: `${myPageData.get(myPageDataEnum.secondaryColor)?.value}`,
                }}
                href={
                  !editModeEnabled
                    ? `tel:${myPageData.get(myPageDataEnum.phone)?.value}`
                    : "#edit"
                }
              >
                <RenderEditItem
                  inputItem={myPageData.get(myPageDataEnum.phone)}
                  editModeEnabled={editModeEnabled}
                  saveAction={webpageEditedAction}
                  placeholder="phone number"
                />
              </a>
            </p>
            <p>
              <a
                target="_blank"
                style={{
                  color: `${myPageData.get(myPageDataEnum.secondaryColor)?.value}`,
                }}
                href={
                  !editModeEnabled &&
                  myPageData.get(myPageDataEnum.socialUrl)?.value
                }
                rel="noreferrer"
              >
                {editModeEnabled ? (
                  <RenderEditItem
                    inputItem={myPageData.get(myPageDataEnum.socialUrl)}
                    editModeEnabled={editModeEnabled}
                    saveAction={webpageEditedAction}
                    placeholder="social media link"
                    inputType="url"
                  />
                ) : (
                  iconLinkMapper(
                    myPageData.get(myPageDataEnum.socialUrl)?.value,
                  )
                )}
              </a>
            </p>
          </div>
          {(myPageData.get(myPageDataEnum.enableSectionOne)?.value ||
            myPageData.get(myPageDataEnum.enableSectionTwo)?.value ||
            myPageData.get(myPageDataEnum.enableSectionThree)?.value) && (
            <div className="footerSitemap">
              <h4>Sitemap</h4>
              {myPageData.get(myPageDataEnum.enableSectionOne)?.value && (
                <a
                  href={`#${myPageData.get(myPageDataEnum.aboutMeTitle)?.value}`}
                  rel="author"
                  style={{
                    color: `${myPageData.get(myPageDataEnum.secondaryColor)?.value}`,
                  }}
                >
                  {myPageData.get(myPageDataEnum.aboutMeTitle)?.value}
                </a>
              )}
              {myPageData.get(myPageDataEnum.enableSectionTwo)?.value && (
                <a
                  href={`#${myPageData.get(myPageDataEnum.serviceItemsTitle)?.value}`}
                  rel="author"
                  style={{
                    color: `${myPageData.get(myPageDataEnum.secondaryColor)?.value}`,
                  }}
                >
                  {myPageData.get(myPageDataEnum.serviceItemsTitle)?.value}
                </a>
              )}
              {myPageData.get(myPageDataEnum.enableSectionThree)?.value && (
                <a
                  href={`#${myPageData.get(myPageDataEnum.otherTitle)?.value}`}
                  rel="author"
                  style={{
                    color: `${myPageData.get(myPageDataEnum.secondaryColor)?.value}`,
                  }}
                >
                  {myPageData.get(myPageDataEnum.otherTitle)?.value}
                </a>
              )}
            </div>
          )}
        </div>
        <div className="footerBottom">
          <p
            style={{
              color: `${myPageData.get(myPageDataEnum.secondaryColor)?.value}`,
            }}
          >
            Created using{" "}
            <a
              href="https://easyzilla.com"
              style={{
                color: `${myPageData.get(myPageDataEnum.secondaryColor)?.value}`,
              }}
              rel="author"
            >
              <b>easyzilla</b>
            </a>
          </p>
          <div
            style={{
              display: allSectionsDisabled ? "none" : "flex",
            }}
            className="toTopButton"
          >
            <a
              href="#top"
              style={{
                color: `${myPageData.get(myPageDataEnum.secondaryColor)?.value}`,
              }}
              rel="author"
            >
              <b>back to top</b>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
